import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function ModulesGrid() {
  const modules = [{
    number: '01',
    title: '🧪 Qué es la creatina (y por qué todo empieza acá)',
    description: 'Entiende qué es realmente la creatina, para qué sirve en tu cuerpo y por qué es uno de los suplementos más estudiados y efectivos.'
  }, {
    number: '02',
    title: '🧬 Cómo funciona en tu cuerpo (la ciencia que nadie te explica bien)',
    description: 'Aprende, de forma simple, qué sucede dentro de tus músculos cuando tomas creatina y por qué mejora el rendimiento y la fuerza.'
  }, {
    number: '03',
    title: '🏷️ Tipos de creatina | La mentira de las creatinas "avanzadas"',
    description: 'Descubre las diferencias entre los distintos tipos de creatina y por qué muchas versiones "avanzadas" son puro marketing.'
  }, {
    number: '04',
    title: '❌ Todo lo que te dijeron mal sobre la creatina',
    description: 'Desmontamos los mitos más comunes: riñones, retención de agua, caída del cabello y otros miedos que circulan en internet.'
  }, {
    number: '05',
    title: '⚠️ ¿Quién NO debería tomar creatina?',
    description: 'Las pocas situaciones donde la creatina puede no ser recomendable y qué precauciones deberías considerar.'
  }, {
    number: '06',
    title: '✅ Cómo tomar creatina correctamente',
    description: 'Dosis, timing, carga sí o no, con qué mezclarla y cómo usarla para obtener resultados reales.'
  }, {
    number: '07',
    title: '🔍 La verdad sobre los sellos de pureza',
    description: 'Qué significan realmente los sellos como Creapure y cómo identificar creatina de buena calidad.'
  }];
  return <section className="w-full bg-[#0E2238] py-20 px-4 sm:px-6 lg:px-8" data-id="element-132">
      <div className="max-w-7xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-134">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#F2F4F8] mb-6" data-id="element-135">
            Qué Aprenderás{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2F6BFF] to-[#7EC8FF]" data-id="element-136">
              Paso a Paso
            </span>
          </h2>
          <p className="text-xl text-[#F2F4F8]/80 max-w-3xl mx-auto" data-id="element-137">
            7 módulos completos que te convertirán en un experto en creatina
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-138">
          {modules.map((module, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.04
        }} className="group bg-[#132A44]/80 border border-[#2F6BFF]/10 rounded-lg px-5 py-4 hover:border-[#2F6BFF]/30 hover:bg-[#132A44] transition-all duration-300" data-id="element-139">
              <div className="flex items-center gap-3 mb-1.5" data-id="element-140">
                <span className="text-xs font-bold text-[#2F6BFF] bg-[#2F6BFF]/15 px-2 py-0.5 rounded-md tracking-wider" data-id="element-141">
                  {module.number}
                </span>
                <h3 className="text-[15px] font-semibold text-[#F2F4F8] leading-snug" data-id="element-142">
                  {module.title}
                </h3>
              </div>
              <p className="text-sm text-[#F2F4F8]/55 leading-relaxed pl-[38px]" data-id="element-143">
                {module.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}